import { toAbsoluteUrl } from '../../../../../utils/toAbsoluteUrl';
import { translate } from '../../../../Internationalization';
import images from '../../../../../config/local/images';
import React from 'react';
import Svg from 'react-inlinesvg';

/**
 * @param {{isGated?: boolean}} props
 * @returns {JSX.Element}
 */
function ValuationTableHeader(props) {
	const header = (
		<h1 className="hl-ms-6 mr-6">
			{translate('agent.pages.widgets.lead_generation.leads')}
		</h1>
	);

	if (props.isGated) {
		return <div className="mb-8 inline-flex items-center">{header}</div>;
	}

	return (
		<div className="mb-8 inline-flex items-center">
			{header}
			<a className="button button-outline button-icon" href="#embed">
				<span>
					{translate(
						'agent.pages.widgets.lead_generation.view_embed_code'
					)}
				</span>
				<i className="icon icon-fill icon-sm">
					<Svg src={toAbsoluteUrl(images.icons.eye)} />
				</i>
			</a>
		</div>
	);
}

export default React.memo(ValuationTableHeader);
